import { Button } from "@/components/ui/button";

export function IllustrationPlaceholder({ icon: Icon, className = "" }) {
  return (
    <div
      className={`relative flex h-32 w-32 items-center justify-center rounded-2xl border border-dashed border-[#00A85A]/30 bg-[#F4FBF7] dark:bg-[#0E1A21] ${className}`}
    >
      <div className="contaha-grid-dim absolute inset-0 rounded-2xl opacity-40" />
      <div className="relative flex flex-col items-center gap-2">
        {Icon && (
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#00A85A]/12">
            <Icon className="h-6 w-6 text-[#00A85A]" strokeWidth={1.75} />
          </div>
        )}
        <span className="text-[9px] font-bold uppercase tracking-wider text-[#8B9698]">Illustration</span>
      </div>
    </div>
  );
}

export function EmptyState({ icon, title, description, actionLabel, onAction, testId }) {
  return (
    <div
      data-testid={testId || "empty-state"}
      className="flex flex-col items-center justify-center rounded-2xl border border-[#E2E8F0] dark:border-[#223139] bg-white dark:bg-[#0E1A21] px-6 py-14 text-center"
    >
      <IllustrationPlaceholder icon={icon} />
      <h3 className="mt-6 text-lg font-bold text-[#101516] dark:text-white">{title}</h3>
      {description && (
        <p className="mt-1.5 max-w-sm text-sm text-[#687173] dark:text-[#8B9698]">{description}</p>
      )}
      {actionLabel && (
        <Button
          onClick={onAction}
          data-testid="empty-state-action"
          className="mt-5 bg-[#00A85A] hover:bg-[#008F4D] text-white rounded-lg"
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
